import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=2d345a1a&scoped=true"
import script from "./InfoTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InfoTab.vue?vue&type=style&index=0&id=2d345a1a&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d345a1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d345a1a')) {
      api.createRecord('2d345a1a', component.options)
    } else {
      api.reload('2d345a1a', component.options)
    }
    module.hot.accept("./InfoTab.vue?vue&type=template&id=2d345a1a&scoped=true", function () {
      api.rerender('2d345a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/InfoTab.vue"
export default component.exports